import { Category } from '../types/content'

export const categories: Category[] = [
  {
    slug: 'weight-metabolic',
    name: 'Weight & Metabolic',
    tagline: 'GLP-1s and metabolic support',
    description:
      'For appetite that will not quit, weight that will not move, and blood sugar that is heading the wrong way. Every plan pairs the medication with bloodwork, so you find out whether it is working instead of guessing.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/11289a40-66eb-4b3a-a0f7-be11b85595af.jpg',
    outcomes: ['Weight that stays off', 'Better blood sugar', 'Muscle you keep'],
  },
  {
    slug: 'recovery-repair',
    name: 'Recovery & Repair',
    tagline: 'Tendons, gut and inflammation',
    description:
      'For the injury that never fully healed and the inflammation underneath it. These are the peptides athletes and physios talk about, prescribed properly and made by a pharmacy you can name.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/4b6feb2b-343f-4625-a319-784e2678cd9b.jpg',
    outcomes: ['Faster recovery', 'Less inflammation', 'A calmer gut'],
  },
  {
    slug: 'growth-hormone',
    name: 'Growth Hormone',
    tagline: 'Secretagogues, not replacement',
    description:
      'These do not hand you growth hormone. They nudge your own pituitary to release it on its normal nightly rhythm, which is why they are dosed at bedtime and cycled with time off.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/7eca17a3-f08e-42ce-9f16-1076307e6405.jpg',
    outcomes: ['Sleep that restores', 'Leaner composition', 'Recovering like you used to'],
  },
  {
    slug: 'longevity-cellular',
    name: 'Longevity & Cellular',
    tagline: 'Energy at the cellular level',
    description:
      'For the tiredness that sleep does not fix. These work on the machinery underneath how you feel day to day — mitochondria, oxidative stress, and the repair systems that slow down with age.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/87ed6623-227d-42a8-9e37-595c904755dc.jpg',
    outcomes: ['Energy that lasts the day', 'Less oxidative stress', 'Better cellular repair'],
  },
  {
    slug: 'cognitive-mood',
    name: 'Cognitive & Mood',
    tagline: 'Focus, stress and clarity',
    description:
      'Nasal sprays for the days you cannot hold a thought, and for a stress response stuck in the on position. Short courses, checked in on before anyone renews them.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/4be191cf-9f5a-470d-b256-809d8cbe30a5.jpg',
    outcomes: ['Sharper focus', 'A calmer baseline', 'More even mood'],
  },
  {
    slug: 'skin-hair',
    name: 'Skin & Hair',
    tagline: 'Collagen, repair and appearance',
    description:
      'Copper peptides and combination stacks for skin that has lost its bounce, scarring that has stuck around, and hair that is thinning. Topical if you would rather not inject.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/0c7a0eb5-4222-4eed-aa23-46ab6890230b.jpg',
    outcomes: ['Firmer skin', 'More collagen', 'Healthier scalp'],
  },
]

export function getCategory(slug: string): Category | undefined {
  return categories.find((category) => category.slug === slug)
}
